/*
  Resilia PDP behaviors (templates/product.resilia_pdp.json).
  Vanilla JS, progressive enhancement: the page renders complete without
  this file; everything here layers interactivity on top.

  Loaded only for the resilia_pdp template from layout/theme.liquid.

  Checkout: the site-wide champs pattern (see assets/buy-page.js and
  patchChampsUrls() in layout/theme.liquid). When champs mode is on and
  the selected tier has a data-coc-url, Add To Cart fires the same
  Klaviyo "Added to Cart" event the rest of the theme fires, re-patches
  UTMs and the li_clickid onto the URL (a JS redirect bypasses the
  theme's DOM patchers, so it must happen here at redirect time), and
  navigates. Otherwise the native form POST to /cart/add goes through.
*/
(function () {
  'use strict';

  /* ------------------------------------------------------------------ *
   *  Countdown timer (evergreen, localStorage-persisted)
   * ------------------------------------------------------------------ */
  function initTimer() {
    var el = document.querySelector('[data-pdpr-timer]');
    if (!el) return;

    var hours = parseFloat(el.getAttribute('data-hours')) || 2;
    var key = el.getAttribute('data-key') || 'sq-resilia-deadline';
    var hEl = el.querySelector('[data-pdpr-timer-h]');
    var mEl = el.querySelector('[data-pdpr-timer-m]');
    var sEl = el.querySelector('[data-pdpr-timer-s]');

    function freshDeadline() {
      var d = Date.now() + hours * 3600 * 1000;
      try { localStorage.setItem(key, String(d)); } catch (e) { /* private mode */ }
      return d;
    }

    var deadline = 0;
    try { deadline = Number(localStorage.getItem(key)); } catch (e) { /* private mode */ }
    if (!deadline || deadline <= Date.now()) deadline = freshDeadline();

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var left = Math.max(0, Math.round((deadline - Date.now()) / 1000));
      if (left === 0) {
        deadline = freshDeadline();
        left = Math.round((deadline - Date.now()) / 1000);
      }
      hEl.textContent = pad(Math.floor(left / 3600));
      mEl.textContent = pad(Math.floor((left % 3600) / 60));
      sEl.textContent = pad(left % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------------ *
   *  Delivery estimate: today + N business days, en-US "Tue, Sep 9"
   * ------------------------------------------------------------------ */
  function initDeliveryDates() {
    document.querySelectorAll('[data-pdpr-delivery]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-days'), 10) || 3;
      var d = new Date();
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var w = d.getDay();
        if (w !== 0 && w !== 6) added++;
      }
      el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    });
  }

  /* ------------------------------------------------------------------ *
   *  Tier store — one source of truth for every buy module + gallery
   * ------------------------------------------------------------------ */
  var tierState = { index: 1 };
  var tierListeners = [];

  function onTierChange(fn) { tierListeners.push(fn); }

  function setTier(index) {
    tierState.index = index;
    tierListeners.forEach(function (fn) { fn(index); });
  }

  function selectedTierCard() {
    return document.querySelector('[data-pdpr-tier][data-index="' + tierState.index + '"]');
  }

  function initBuyModules() {
    var modules = document.querySelectorAll('[data-pdpr-buy]');
    if (!modules.length) return;

    modules.forEach(function (module) {
      module.querySelectorAll('[data-pdpr-tier]').forEach(function (card) {
        function pick() { setTier(parseInt(card.getAttribute('data-index'), 10) || 0); }
        card.addEventListener('click', pick);
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
        });
      });
    });

    onTierChange(function (index) {
      modules.forEach(function (module) {
        var selected = null;

        module.querySelectorAll('[data-pdpr-tier]').forEach(function (card) {
          var isSelected = parseInt(card.getAttribute('data-index'), 10) === index;
          card.classList.toggle('is-selected', isSelected);
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          if (isSelected) selected = card;
        });
        if (!selected) return;

        module.querySelectorAll('[data-pdpr-price]').forEach(function (el) {
          el.textContent = selected.getAttribute('data-price');
        });
        module.querySelectorAll('[data-pdpr-compare]').forEach(function (el) {
          el.textContent = selected.getAttribute('data-compare');
        });
        module.querySelectorAll('[data-pdpr-save]').forEach(function (el) {
          el.textContent = selected.getAttribute('data-save');
        });

        var idInput = module.querySelector('[data-pdpr-atc-id]');
        if (idInput) idInput.value = selected.getAttribute('data-variant-id');

        module.querySelectorAll('[data-pdpr-gift]').forEach(function (slot) {
          var giftIndex = parseInt(slot.getAttribute('data-index'), 10) || 0;
          var locked = giftIndex > index;
          slot.classList.toggle('is-locked', locked);
          var nameEl = slot.querySelector('[data-pdpr-gift-name]');
          if (nameEl) nameEl.textContent = locked ? 'Locked' : slot.getAttribute('data-name');
        });
      });
    });
  }

  /* ------------------------------------------------------------------ *
   *  Add To Cart — champs redirect with Klaviyo + UTM/clickid patching
   * ------------------------------------------------------------------ */
  function patchTrackingParams(rawUrl) {
    var url;
    try { url = new URL(rawUrl); } catch (e) { return rawUrl; }

    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, k) {
      var lower = k.toLowerCase();
      if ((lower === 'utm' || lower.indexOf('utm_') === 0) && !url.searchParams.has(k)) {
        url.searchParams.append(k, value);
      }
    });

    var clickid = null;
    try { clickid = localStorage.getItem('li_clickid'); } catch (e) { /* private mode */ }
    if (clickid && !url.searchParams.has('clickid')) {
      url.searchParams.set('clickid', clickid);
    }

    return url.toString();
  }

  function trackAddedToCart(card) {
    if (!window.klaviyo) return;
    var priceCents = parseFloat(card.getAttribute('data-price-cents') || 0);
    window.klaviyo.push([
      'track',
      'Added to Cart',
      {
        $value: priceCents / 100,
        AddedItemProductName: card.getAttribute('data-title') || '',
        AddedItemProductID: card.getAttribute('data-variant-id') || '',
        AddedItemSKU: card.getAttribute('data-variant-id') || '',
        AddedItemImageURL: card.getAttribute('data-image') || '',
        AddedItemURL: card.getAttribute('data-url') || window.location.href,
        AddedItemPrice: priceCents / 100,
        AddedItemQuantity: 1
      }
    ]);
  }

  function initAtc() {
    document.querySelectorAll('[data-pdpr-atc-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var module = form.closest('[data-pdpr-buy]');
        if (!module || module.getAttribute('data-champs-mode') !== 'true') return;

        var card = selectedTierCard();
        var cocUrl = card && card.getAttribute('data-coc-url');
        if (!cocUrl) return; // fall through to the native /cart/add POST

        event.preventDefault();
        trackAddedToCart(card);
        window.location.href = patchTrackingParams(cocUrl);
      });
    });
  }

  /* ------------------------------------------------------------------ *
   *  Gallery: 11 slides, wrap-around, tier-swapped slide 1
   * ------------------------------------------------------------------ */
  function initGallery() {
    var gallery = document.querySelector('[data-pdpr-gallery]');
    if (!gallery) return;

    var main = gallery.querySelector('[data-pdpr-gallery-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.pdpr-gallery__thumb'));
    var slides = thumbs.map(function (t) { return t.getAttribute('data-full'); });
    if (!slides.length || !main) return;

    var current = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;
      main.src = slides[current];
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });
    var prev = gallery.querySelector('[data-pdpr-gallery-prev]');
    var next = gallery.querySelector('[data-pdpr-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    onTierChange(function (index) {
      var full = gallery.getAttribute('data-slide1-' + index);
      var thumbSrc = gallery.getAttribute('data-slide1-thumb-' + index);
      if (full) {
        slides[0] = full;
        var thumbImg = thumbs[0] && thumbs[0].querySelector('img');
        if (thumbs[0]) thumbs[0].setAttribute('data-full', full);
        if (thumbImg && thumbSrc) thumbImg.src = thumbSrc;
      }
      show(0); // design resets to slide 1 on tier change
    });
  }

  /* ------------------------------------------------------------------ *
   *  Carousels: one scrollRow helper, arrows, dot sync
   * ------------------------------------------------------------------ */
  function rowGap(row) {
    var gap = parseFloat(getComputedStyle(row).columnGap);
    return isNaN(gap) ? 20 : gap;
  }

  function cardWidth(row) {
    var card = row.firstElementChild;
    return card ? card.getBoundingClientRect().width + rowGap(row) : row.clientWidth;
  }

  function scrollRow(row, dir) {
    var w = cardWidth(row);
    var max = row.scrollWidth - row.clientWidth;
    var next = row.scrollLeft + dir * w;
    if (next > max + 4) next = 0;
    else if (next < -4) next = max;
    row.scrollTo({ left: next, behavior: 'smooth' });
  }

  function initCarousels() {
    var dotIndexes = {};

    document.querySelectorAll('[data-pdpr-dots]').forEach(function (dots) {
      var name = dots.getAttribute('data-pdpr-dots');
      var buttons = Array.prototype.slice.call(dots.querySelectorAll('.pdpr-dot'));
      dotIndexes[name] = { buttons: buttons, index: 0 };

      buttons.forEach(function (button, i) {
        button.addEventListener('click', function () {
          var row = document.querySelector('[data-pdpr-row="' + name + '"]');
          if (row) row.scrollTo({ left: i * cardWidth(row), behavior: 'smooth' });
          setDot(name, i);
        });
      });
    });

    function setDot(name, index) {
      var entry = dotIndexes[name];
      if (!entry) return;
      entry.index = (index + entry.buttons.length) % entry.buttons.length;
      entry.buttons.forEach(function (button, i) {
        button.classList.toggle('is-active', i === entry.index);
      });
    }

    function bindArrow(attr, dir) {
      document.querySelectorAll('[' + attr + ']').forEach(function (button) {
        var name = button.getAttribute(attr);
        button.addEventListener('click', function () {
          var row = document.querySelector('[data-pdpr-row="' + name + '"]');
          if (row) scrollRow(row, dir);
          if (dotIndexes[name]) setDot(name, dotIndexes[name].index + dir);
        });
      });
    }

    bindArrow('data-pdpr-prev', -1);
    bindArrow('data-pdpr-next', 1);
  }

  /* ------------------------------------------------------------------ *
   *  Stats count-up: once, at 30% visibility, 1.5s cubic ease-out
   * ------------------------------------------------------------------ */
  function initStats() {
    var band = document.querySelector('[data-pdpr-stats]');
    if (!band || !('IntersectionObserver' in window)) return;

    var counters = Array.prototype.slice.call(band.querySelectorAll('[data-pdpr-count]'));
    if (!counters.length) return;

    var targets = counters.map(function (el) { return parseInt(el.getAttribute('data-to'), 10) || 0; });
    counters.forEach(function (el) { el.textContent = '0'; });

    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      observer.disconnect();

      var start = performance.now();
      var duration = 1500;

      function step(now) {
        var p = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        counters.forEach(function (el, i) {
          el.textContent = Math.round(targets[i] * eased).toLocaleString('en-US');
        });
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, { threshold: 0.3 });

    observer.observe(band);
  }

  /* ------------------------------------------------------------------ *
   *  Journey sweep: once, at 35% visibility, 3.2s bar -> connector fill
   * ------------------------------------------------------------------ */
  function initJourney() {
    var timeline = document.querySelector('[data-pdpr-journey]');
    if (!timeline || !('IntersectionObserver' in window)) return;

    var stages = Array.prototype.slice.call(timeline.querySelectorAll('[data-pdpr-stage]'));
    if (!stages.length) return;

    function paint(lit) {
      stages.forEach(function (stage, i) {
        // each stage = 1 unit: first half fills the bar, second half its connector
        var u = Math.max(0, Math.min(1, lit - i));
        var barP = Math.min(1, u * 2);
        var lineP = Math.max(0, u * 2 - 1);
        stage.style.setProperty('--pdpr-bar', Math.round(barP * 100) + '%');
        stage.style.setProperty('--pdpr-line', Math.round(lineP * 100) + '%');
        stage.classList.toggle('is-lit', u > 0);
      });
    }

    paint(0); // server renders fully lit for no-JS; zero it before animating

    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      observer.disconnect();

      var start = performance.now();
      var duration = 3200;

      function step(now) {
        var p = Math.min(1, (now - start) / duration);
        paint(p * stages.length);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, { threshold: 0.35 });

    observer.observe(timeline);
  }

  /* ------------------------------------------------------------------ *
   *  Single-open <details> groups (buy-box accordions, benefit rows)
   * ------------------------------------------------------------------ */
  function initSingleOpen() {
    document.querySelectorAll('details[data-pdpr-single]').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        var group = details.getAttribute('data-pdpr-single');
        document.querySelectorAll('details[data-pdpr-single="' + group + '"]').forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });
  }

  /* ------------------------------------------------------------------ *
   *  UGC video cards
   *  hover -> muted preview; click -> play with sound (one at a time);
   *  click again -> pause; scrolled out of view or a click outside any
   *  card -> everything stops and the play glyphs come back.
   * ------------------------------------------------------------------ */
  function initUgcVideos() {
    var cards = Array.prototype.slice
      .call(document.querySelectorAll('[data-pdpr-ugc-card]'))
      .filter(function (card) { return card.querySelector('[data-pdpr-ugc-video]'); });
    if (!cards.length) return;

    var active = null;

    function play(video) {
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    }

    function stop(card, rewind) {
      var video = card.querySelector('[data-pdpr-ugc-video]');
      var toggle = card.querySelector('[data-pdpr-ugc-toggle]');
      if (!video) return;
      video.pause();
      video.muted = true;
      if (rewind) video.currentTime = 0;
      card.classList.remove('is-playing');
      if (toggle) toggle.setAttribute('aria-label', 'Play video');
      if (active === card) active = null;
    }

    function stopAll(except) {
      cards.forEach(function (card) {
        if (card !== except) stop(card, true);
      });
    }

    cards.forEach(function (card) {
      var video = card.querySelector('[data-pdpr-ugc-video]');
      var toggle = card.querySelector('[data-pdpr-ugc-toggle]');

      card.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch') return;
        if (card === active) return;
        video.muted = true;
        play(video);
      });

      card.addEventListener('pointerleave', function () {
        if (card === active) return;
        video.pause();
        video.currentTime = 0;
      });

      if (!toggle) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();

        // second click on the playing card: pause, keep the frame + sound
        if (card === active) {
          video.pause();
          card.classList.remove('is-playing');
          toggle.setAttribute('aria-label', 'Play video');
          active = null;
          return;
        }

        stopAll(card);
        video.muted = false;
        card.classList.add('is-playing');
        toggle.setAttribute('aria-label', 'Pause video');
        active = card;
        play(video);
      });
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-pdpr-ugc-card]')) return;
      stopAll(null);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) stop(entry.target, true);
        });
      }, { threshold: 0.35 });
      cards.forEach(function (card) { observer.observe(card); });
    }
  }

  /* ------------------------------------------------------------------ */
  function init() {
    initTimer();
    initDeliveryDates();
    initBuyModules();
    initAtc();
    initGallery();
    initCarousels();
    initStats();
    initJourney();
    initUgcVideos();
    initSingleOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
